import React from 'react';
import { motion } from 'framer-motion';
import { FaMoneyBillWave } from 'react-icons/fa';

export default function PaymentInfo() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-md p-6"
    >
      <div className="flex items-center gap-3 mb-4 pb-2 border-b-2 border-red-700">
        <FaMoneyBillWave className="text-red-700 w-6 h-6" />
        <h3 className="text-xl font-bold text-red-700">
          BETALING
        </h3>
      </div>
      
      <div className="flex items-center gap-2">
        <span>Vi modtager kontanter og kort</span>
        <div className="flex items-center gap-1">
          <span></span>
        </div>
      </div>
    </motion.div>
  );
}